import { Telemetry } from '../telemetry/Telemetry';

import { LoggerAdapter } from './LoggerAdapter';
import { TelemetryLogger } from './TelemetryLogger';

export const Logger: LoggerAdapter = new TelemetryLogger(Telemetry);
